<div class="asm-backdrop">
  <div class="asm-card">
    <div class="asm-success-icon">
      <i class="bx bxs-check-circle"></i>
    </div>

    <h2 class="asm-title">You're All Set!</h2>
    <p class="asm-subtitle">Thank you for accepting our agreement. Here's what happens next.</p>

    <ol class="asm-steps">
      <li class="asm-step">
        <span class="asm-step-icon"><i class="bx bx-desktop"></i></span>
        <span class="asm-step-text">Go to the <b>Hardware</b> menu.</span>
      </li>
      <li class="asm-step">
        <span class="asm-step-icon"><i class="bx bx-toggle-right"></i></span>
        <span class="asm-step-text">Enable your POS provider.</span>
      </li>
      <li class="asm-step asm-step-pending">
        <span class="asm-step-icon"><i class="bx bx-support"></i></span>
        <span class="asm-step-text">
          Once the provider integration succeeds, our support team will activate your account.
        </span>
      </li>
      <li class="asm-step">
        <span class="asm-step-icon"><i class="bx bx-cart"></i></span>
        <span class="asm-step-text">After activation, you can start taking orders with us.</span>
      </li>
    </ol>

    <div class="asm-actions">
      <button type="button" class="btn btn-neutral rounded-3" (click)="integrateLater.emit()">
        Integrate Later
      </button>
      <button type="button" class="btn btn-dark rounded-3" (click)="goToHardware.emit()">
        Go to Hardware
        <i class="bx bx-right-arrow-alt"></i>
      </button>
    </div>
  </div>
</div>
